import { faCircleExclamation, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover } from 'antd';
import React from 'react';

const HideValue = ({
  showPopOver,
  popOverMessage,
  iconSize,
  customStyle,
}) => (
  showPopOver ? (
    <Popover
      placement="topRight"
      content={popOverMessage || "You don't have access to view this content"}
      title={(
        <span>
          <FontAwesomeIcon icon={faCircleExclamation} style={{ color: '#ff4d4f' }} />
          {' '}
          Restricted Access
        </span>
      )}
    >
      <FontAwesomeIcon icon={faEyeSlash} size={iconSize} style={customStyle} />
    </Popover>
  ) : <FontAwesomeIcon icon={faEyeSlash} size={iconSize} />
);

export default HideValue;
